import React, {useEffect} from 'react'
import {ArrowButton, BarWrap, LeftBar, RightBar, SquareIcon} from './styles.js';
import Icon from '../../../atoms/UI/Icon/Icon'
import {useDispatch, useSelector} from 'react-redux'
import {setActiveQuestion, setIsFinished} from '../../../../store/reducers/testingSlice.js'
import {
    findIfLiked,
    likeClick,
    resetReactionState,
    setActiveButton,
    setReactionState
} from '../../../../store/reducers/likesSlice.js'
import {useModal} from '../../../../core/hooks/useModal'
import ReportForm from '../ReportForm/ReportForm'
import { resetSuccessMessage } from '@/store/reducers/reportFormSlice';

type TestButtonBarProps = {
    cssBack?: string
}

const TestButtonBar: React.FC<TestButtonBarProps> = (
    {cssBack}
) => {
    const {activeQuestion, isFinished, testData, answers, answerState, isFormValid} =
        useSelector((state: any) => state.testing);

    const {reactionState, activeButton} =
        useSelector((state: any) => state.likes);

    const successMessage = useSelector((state: any) => state.reportForm.successMessage);


    const [isNextBtn, setIsNextBtn] = React.useState(false);

    const currentQuestionId: any = testData[activeQuestion]?.id;
    const currentQuestionNextBtnShow: any = testData[activeQuestion]?.question?.nextBtnShow;
    const currentQuestionPrevBtnHide: any = testData[activeQuestion]?.question?.prevBtnHide;
    const answerExists = answers[activeQuestion]?.answer.length > 0 && answers[activeQuestion].answer[0].name != null;
    const dispatch = useDispatch()

    const { show: openReportModal, RenderModal: RenderReportModal } = useModal();

    useEffect(() => {
        dispatch(findIfLiked(currentQuestionId))
    }, [activeQuestion])

    useEffect(() => {
        // show "Next" button
        const shouldShowNextBtn = answerExists && (currentQuestionNextBtnShow || !answerState.isSelected);
        setIsNextBtn(shouldShowNextBtn);

    }, [activeQuestion, answers, currentQuestionNextBtnShow, isFinished, answerState.isSelected, answerExists]);

    const onBackClick = () => {
        dispatch(setActiveQuestion(activeQuestion - 1))
    }

    const onNextClick = () => {
        if (currentQuestionNextBtnShow) {
            setIsNextBtn(false)
        }
        if (activeQuestion + 1 === testData.length) {
            dispatch(setIsFinished(true));

        } else {
            dispatch(setActiveQuestion(activeQuestion + 1))
        }
    }

    const onLikeClick = () => {
        if (activeButton === 'like') {
            dispatch(likeClick(0, currentQuestionId));
        } else {
            dispatch(likeClick(1, currentQuestionId));
            dispatch(setActiveButton('like'));
            dispatch(setReactionState(1));
        }
    };

    const onDislikeClick = () => {
        if (activeButton === 'dislike') {
            dispatch(likeClick(0, currentQuestionId));
        } else {
            dispatch(likeClick(-1, currentQuestionId));
            dispatch(setActiveButton('dislike'));
            dispatch(setReactionState(-1));
        }
    };

    const showReportForm = () => {
        dispatch(resetSuccessMessage());  // Сбрасываем successMessage при каждом открытии модального окна
        openReportModal();
    };

    return (
        <>
            <BarWrap cssBack={cssBack}>
                <LeftBar>
                    {!isFinished && activeQuestion > 0
                        && !currentQuestionPrevBtnHide
                        && (
                        <ArrowButton type='button' onClick={onBackClick}>
                            <Icon name='Back' small />
                        </ArrowButton>
                    )}
                    {isNextBtn && isFormValid && (
                        <ArrowButton type='button' onClick={onNextClick} className='accept'>
                            <Icon name='Next' small />
                        </ArrowButton>
                    )}
                </LeftBar>
                <RightBar>
                    <SquareIcon type='button' className=
                                    {`${(activeButton === 'like') && 'animate'}
                                    ${(activeButton === 'like') || (reactionState === 1) ? ' like' : ''}`}
                                onClick={onLikeClick}>
                        <Icon name="Like" />
                    </SquareIcon>

                    <SquareIcon type='button' className=
                                    {`${(activeButton === 'dislike') && 'animate'} 
                                    ${(activeButton === 'dislike') || (reactionState === -1) ? 'dislike' : ''}`}
                                onClick={onDislikeClick}>
                        <Icon name='Dislike' />
                    </SquareIcon>
                    <SquareIcon type='button' className='' onClick={showReportForm}>
                        <Icon name='Report'/>
                    </SquareIcon>
                </RightBar>
            </BarWrap>

            <RenderReportModal unclosed={successMessage} mode={successMessage ? 'successPrompt' : ''}>
                <ReportForm question_id={currentQuestionId}/>
            </RenderReportModal>
        </>
    )
}

export default TestButtonBar